import React, { useState, useRef, useEffect } from "react";

import {
  FAVORITES_SORT_OPTIONS,
  DEFAULT_DIRECTION,
  labelForSort,
} from "../utils/favoritesSort";

// Sort dropdown used on the Favorites page and the favorites grid page.
// Clicking the active option flips direction; a new option uses its default.
const FavoritesSortPill = ({ option, direction, onChange }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };

    document.addEventListener("mousedown", onDocClick);

    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  const arrow = direction === "asc" ? "↑" : "↓";

  const select = (id) => {
    if (id === option) {
      onChange(id, direction === "asc" ? "desc" : "asc");
    } else {
      onChange(id, DEFAULT_DIRECTION[id] || "asc");
    }
    setOpen(false);
  };

  return (
    <div className="relative" ref={ref}>
      <button
        className="flex items-center gap-2 rounded-xl border border-white/15 bg-white/[0.06] px-4 py-2 text-sm text-white backdrop-blur-md transition-colors hover:bg-white/[0.12]"
        type="button"
        onClick={() => setOpen((v) => !v)}
      >
        <i className="fas fa-sort text-gray-400" />
        <span>{labelForSort(option)}</span>
        {option !== "custom" && <span className="text-blue-400">{arrow}</span>}
        <i
          className={`fas fa-chevron-${open ? "up" : "down"} text-xs text-gray-400`}
        />
      </button>

      {open && (
        <div className="absolute right-0 z-50 mt-2 w-56 rounded-xl border border-white/15 bg-gray-900/95 p-2 shadow-2xl backdrop-blur-2xl">
          {FAVORITES_SORT_OPTIONS.map((o) => {
            const active = o.id === option;

            return (
              <button
                className={`flex w-full items-center justify-between rounded-lg px-3 py-2.5 text-left text-sm transition-colors ${
                  active
                    ? "bg-white font-semibold text-gray-900"
                    : "text-gray-200 hover:bg-white/10"
                }`}
                key={o.id}
                type="button"
                onClick={() => select(o.id)}
              >
                <span>{o.label}</span>
                {active && <span>{arrow}</span>}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FavoritesSortPill;
